import { Box } from '@chakra-ui/react';
import { PROJECTS_BY_ID } from '@content/partners';
import { AppLink, BadgeColor, LANDING_ROUTES, SHARED_ROUTES } from '@cyberkongz/ui';
import { ReactNode } from 'react';

const TWITTER_INURASHI = { href: 'https://twitter.com/0xinuarashi', label: '0xinuarashi' };
const TWITTER_GASPACHO = { href: 'https://twitter.com/gaspacho_eth', label: 'gaspacho_eth' };
const TWITTER_BANTERLYTICS = { href: 'https://twitter.com/banterlytics', label: 'banterlytics' };
const TWITTER_MAS_ON_THE_CHAIN = {
  href: 'https://twitter.com/MasOnTheChain',
  label: 'MasOnTheChain',
};
const TWITTER_FLIPSIDECRYPTO = {
  href: 'https://twitter.com/flipsidecrypto',
  label: 'Flipside',
};
const TWITTER_APA_1995 = { href: 'https://twitter.com/apa_1995', label: 'apa_1995' };
const TWITTER_MAXBRAND99 = { href: 'https://twitter.com/maxbrand99', label: 'maxbrand99' };
const TWITTER_SUBDUENFT = { href: 'https://twitter.com/subduenft', label: 'subduenft' };

type Author = { href: string; label: string };
type PoweredBy = Author;
export type Subcard = { title?: string; description?: ReactNode; image: string };

// TO DO nice cardImage and subcards typing |
type CardBase = {
  title: string;
  description: ReactNode;
  subcards?: Subcard[];
};

type CardWithBadge = { badgeLabel: string; badgeColor: BadgeColor };

type CardCommunity = CardBase & {
  image?: string;
  cardImage?: string;
  href?: string;
  authors?: Author[];
  poweredBy?: PoweredBy[];
};

type CardTools = CardBase & {
  cardImage?: string;
  href: string;
  authors: Author[];
};

type CardEcosystem = CardBase &
  CardWithBadge & {
    cardImage: string;
    href?: string;
  };

type CardIrl = CardBase &
  CardWithBadge & {
    image: string;
    cardImage?: string;
    href: string;
  };

type CardMetaverse = CardBase & {
  image: string;
  cardImage?: string;
  href: string;
};

type CardSocialImpact = CardBase &
  CardWithBadge & {
    image: string;
    cardImage?: string;
    href: string;
  };

export const CARDS_COMMUNITY: CardCommunity[] = [
  {
    title: 'On-chain kongz',
    description:
      'On-Chain Kongz were created to ensure our Kongz live forever on the blockchain. This is the original art of our 2D Kongz. These Kongz are fully on-chain, 100% decentralized, trustless, and without any back-end server or IPFS. They are “Gallery” pieces that are completely Gasless, non-user-transferable, and will always automatically transfer to the new owner`s wallet on any transfer of CyberKongz.',
    cardImage: 'onchain_kongz',
    href: SHARED_ROUTES.ONCHAIN_KONGZ,
    authors: [TWITTER_INURASHI],
  },
  {
    title: 'analytics webapp',
    description:
      'Our own analytics WebApp built by community member Banterlytics and his team. Real-time CyberKongz data at the tip of your fingers including unique holders, secondary volume, $BANANA burn & more! ',
    cardImage: 'analytics_app',
    href: SHARED_ROUTES.ANALYTICS,
    authors: [TWITTER_BANTERLYTICS, TWITTER_MAS_ON_THE_CHAIN],
    poweredBy: [TWITTER_FLIPSIDECRYPTO],
    subcards: [{ image: 'analytics_app_1.jpg' }, { image: 'analytics_app_2.jpg' }],
  },
  {
    title: 'kongbot',
    description:
      'As Discord has become a key communication platform in Web3, so too have the prolific security issues. KongBot has been programmed to protect our server and our holders. Amongst many features, KongBot will alert team members and moderators in Discord, if a verified CyberKongz holders is interacting with a malicious contract. KongBot is upgraded as new security measures are discovered.',
    cardImage: 'kongbot',
    href: SHARED_ROUTES.TWITTER_KONGBOT,
    authors: [TWITTER_APA_1995],
  },
  {
    title: 'OOH: Community Voting',
    description:
      'OOH is our first iteration towards community governance. It is our first step to establish a solid foundation for facilitating decentralized decision making within the community. ',
    image: 'snapshot',
    cardImage: 'snapshot',
  },
];

export const CARDS_TOOLS: CardTools[] = [
  {
    title: 'KongzMart',
    description: 'A whitelist marketplace powered by Play & Kollect',
    cardImage: 'kongzmart',
    href: SHARED_ROUTES.KONGZ_MART,
    authors: [TWITTER_INURASHI, TWITTER_GASPACHO],
  },
  {
    title: 'Guardian App',
    description:
      'The Guardian App lets you lock or unlock your VX Kongz via a secondary Guardian Address. Locked VX Kongz cannot be transferred and remain safe even if their owner`s address gets compromised.',
    cardImage: 'guardian',
    href: SHARED_ROUTES.GUARDIAN,
    authors: [TWITTER_GASPACHO],
  },
  {
    title: 'nana calc',
    description:
      'The Nana Calc is a tool used to calculate the amount of runs, $BANANA and Kongium required to level up a VX Kong or a team of VX Kongz. Developed by one of our amazing community members, Subdue!. ',
    cardImage: 'nana_calc',
    href: SHARED_ROUTES.NANA_CALC,
    authors: [TWITTER_SUBDUENFT],
  },
  {
    title: 'max`s script',
    description:
      'Max is well known in the Axie community for developing breeding scripts. In the early days of Play & Collect users could only run a single Adventure Run through the website. For players who wanted to quickly level up their VX’s, this would take a significant amount of time. Max created a script where users could input a desired amount of runs, and the script would initiate those transactions for them. This allowed for executing multiple runs with minimal effort.',
    cardImage: 'max_script',
    href: SHARED_ROUTES.MAX_SCRIPT,
    authors: [TWITTER_MAXBRAND99],
  },
  {
    title: 'Cyberkongz vx 2demaker 2000 remix',
    description: `Turn your VX into pixels with the CyberKongz VX 2Demaker 2000 Remix! Input your desired VX' ID, choose the level of pixelation and let the magic happen.`,
    cardImage: 'vx_2demaker',
    href: SHARED_ROUTES.VX_2DEMAKER_2000,
    authors: [TWITTER_GASPACHO],
  },
];

export const CARDS_ECOSYSTEM: CardEcosystem[] = [
  {
    title: 'THE KOLLECTIONS',
    description:
      'We are a family of 20,000 CyberKongz split into 3 distinct types of Kongz: Genesis, Baby and VX. Each with unique utilities and traits!',
    badgeLabel: 'Growing',
    badgeColor: 'primary',
    cardImage: 'kollections',
    href: LANDING_ROUTES.KOLLECTIONS,
    subcards: [
      {
        image: 'kollections_1.jpg',
      },
      {
        image: 'kollections_2.jpg',
      },
      {
        image: 'kollections_3.jpg',
      },
    ],
  },
  {
    title: '$banana',
    description:
      '$BANANA sits at the core of everything in the CyberKongz universe. It is often regarded as the first real use case of NFT utility in the Metaverse. $BANANA acts as both a utility and governance token in the CyberKongz ecosystem.',
    badgeLabel: 'Growing',
    badgeColor: 'primary',
    cardImage: 'banana',
    href: LANDING_ROUTES.BANANA,
  },
  {
    title: 'PLAY & KOLLECT: JUNGLE ADVENTURE',
    description:
      'Jungle Adventure is a gamified minting experience that rewards holders with rare items and NFTs using our Play & Kollect (PnK) mechanism. In the future, community members and partners can build on top of PnK where token yield and airdrops can be distributed through the same mechanism!',
    badgeLabel: 'Growing',
    badgeColor: 'primary',
    cardImage: 'play_and_kollect',
    href: LANDING_ROUTES.PLAY_AND_KOLLECT,
  },
  {
    title: 'metaverse',
    description:
      'As a natural evolution of our growth, we`ve made some solid moves over time to kick start our journey in building sustainable ecosystem in the metaverse. ',
    badgeLabel: 'In Progress',
    badgeColor: 'tertiary',
    cardImage: 'metaverse',
  },
];

export const CARDS_IRL: CardIrl[] = [
  {
    title: 'CyberKongz x about you',
    description:
      'The iconic IP of CyberKongz meets mainstream streetwear, as CyberKongz partners with the largest retailer in the EU, About You.',
    image: PROJECTS_BY_ID.about_you.image,
    badgeLabel: 'Launched',
    badgeColor: 'primary',
    cardImage: 'about_you',
    href: 'https://www.aboutyou.com/s/about-you-x-cyberkongz-101915',
    subcards: [
      {
        image: 'about_you_1.jpg',
      },
      {
        image: 'about_you_2.jpg',
      },
      {
        image: 'about_you_3.jpg',
      },
    ],
  },
  {
    title: 'CyberKongz x Under Armour',
    description:
      'The CyberKongz "Up Front" collection was launched on Aug. 22, 2022, in partnership with Under Armour. More than 30 apparel choices are available!',
    image: PROJECTS_BY_ID.under_armour.image,
    badgeLabel: 'Launched',
    badgeColor: 'primary',
    cardImage: 'under_armour',
    href: LANDING_ROUTES.MERCH_UNDER_ARMOUR,
    subcards: [
      {
        image: 'under_armour_1.jpg',
      },
      {
        image: 'under_armour_2.jpg',
      },
      {
        image: 'under_armour_3.jpg',
      },
    ],
  },
  {
    title: 'CyberKongz x VIVIENNE TAM',
    description:
      'CyberKongz took to the runway at New York Fashion Week 2022!  Vivienne Tam brought the digital world into the physical in a collection that blends genders and generations!',
    image: PROJECTS_BY_ID.vivienne_tam.image,
    badgeLabel: 'Launched',
    badgeColor: 'primary',
    cardImage: 'vivienne_tam',
    href: 'https://www.viviennetam.com/pages/ss2023',
    subcards: [
      {
        image: 'vivienne_tam_1.jpg',
      },
      {
        image: 'vivienne_tam_2.jpg',
      },
    ],
  },
  {
    title: 'CyberKongz x Uniqly',
    description:
      'CyberKongz & Uniqly proudly present a timeless, classic, and redeemable NFT Streetwear collection for you to enjoy! Anyone owning a CyberKongz: Genesis, Baby or VX was able to mint 2 pieces and redeem them for real life merchandise. Boldly representing Kongz on the streets, and in the metaverse and AR!',
    image: PROJECTS_BY_ID.uniqly.imageAlt || PROJECTS_BY_ID.uniqly.image,
    badgeLabel: 'Sold Out',
    badgeColor: 'primary',
    cardImage: 'uniqly',
    href: 'https://www.uniqly.io/stores/cyberkongz2',
    subcards: [
      {
        image: 'uniqly_1.jpg',
      },
      {
        image: 'uniqly_2.jpg',
      },
      {
        image: 'uniqly_3.jpg',
      },
    ],
  },
];

export const CARDS_METAVERSE: CardMetaverse[] = [
  {
    ...PROJECTS_BY_ID.sandbox,
    description:
      'CyberKongz owns a total of 800 LANDs in the SandBox. CyberKong VX owners will be able to use their NFT as an avatar, and equip wearables minted from Play & Kollect.',
    subcards: [
      {
        title: 'The Shrine of Kongz @ THE SANDBOX',
        description: (
          <Box>
            In July 2021, CyberKongz won the auction for The Shrine of Truth, a one of a kind
            landmark built by SandRush x Nabiya on a 3x3 estate, and renamed it The Shrine of Kongz.
          </Box>
        ),
        image: 'sandbox_1.jpg',
      },
      {
        title: 'Neo Kongz City @ THE SANDBOX',
        description: (
          <Box>
            The CryptoCities themed capitol serves as a concept and will eventually be built out as
            an 4x4 in the middle of the 576 plots of the 24x24 estate called Kongz Island.
          </Box>
        ),
        image: 'sandbox_2.jpg',
      },
      {
        title: 'Kongz Island @ THE SANDBOX',
        description: (
          <Box>Our second estate in The Sandbox, which will be developed on a 12x12 estate.</Box>
        ),
        image: 'sandbox_3.jpg',
      },
    ],
  },
  {
    ...PROJECTS_BY_ID.axie_infinity,
    description:
      'CyberKongz owns 110 Forest plots. Though land gameplay is still being developed, Axie Land of ‘Lunacia’ will be the base of operation for Axies as resources spawn there and upgrades can be made from crafting/producing. Land holders get first rights to these generated resources which includes AXS tokens, wood, stone, and potentially other special items. All 110 Forest plots are being staked and yield 28.6 AXS per day.',
    subcards: [
      {
        image: 'axie_infinity_1.jpg',
      },
      {
        image: 'axie_infinity_2.jpg',
      },
    ],
  },
  {
    ...PROJECTS_BY_ID.guild_of_guardians,
    description:
      'Kongz hold 50 Adventurers Guild tokens and 2 Warrior Guild tokens. The Kongz team also owns 1000+ rare heroes which Kongz holders can use in different game modes such as guild raids, PvP, and other land gameplay.',
    subcards: [
      {
        image: 'guild_of_guardians_1.jpg',
      },
      {
        image: 'guild_of_guardians_2.jpg',
      },
      {
        image: 'guild_of_guardians_3.jpg',
      },
      {
        image: 'guild_of_guardians_4.jpg',
      },
    ],
  },
  {
    ...PROJECTS_BY_ID.ember_sword,
    description: (
      <>
        <Box mb={5}>
          CyberKongz owns 63 plots of Ember Sword land. 46 regular plots, 16 city plots, and 1
          settlement plot.
        </Box>
        <Box>
          Ember Sword is building a MMORPG experience with a full in-game economy. It is powered by
          the premium currency that is generated by land. They do this by distributing 50% of the
          revenues generated inside the Ember Sword world amongst the land owners in the form of
          ERC-20 tokens. Kongz could form guilds through their city to bring activity and add value.
        </Box>
      </>
    ),
    subcards: [
      {
        image: 'ember_sword_1.jpg',
      },
      {
        image: 'ember_sword_2.jpg',
      },
    ],
  },
  {
    ...PROJECTS_BY_ID.webb,
    description:
      'Kongz acquired a Penthouse in Worldwide Webb! This penthouse should be able to host hundreds of people, in a Kongz themed environment. Yield/airdrops can be rewarded to holders through P&K.',
    subcards: [
      {
        image: 'webb_1.jpg',
      },
      {
        image: 'webb_2.jpg',
      },
      {
        image: 'webb_3.jpg',
      },
    ],
  },
  {
    ...PROJECTS_BY_ID.arcade_land,
    description: (
      <Box>
        CyberKongz acquired 1 of{' '}
        <AppLink href="https://twitter.com/CyberKongz/status/1520459566827323394">
          32 mega-sized plots
        </AppLink>
        . Holders will be able to play as a Kongz character in their metaverse.
      </Box>
    ),
    subcards: [
      {
        image: 'arcade_land_1.jpg',
      },
      {
        image: 'arcade_land_2.jpg',
      },
    ],
  },
  {
    ...PROJECTS_BY_ID.nemus_earth,
    description: (
      <>
        <Box mb={5}>
          Nemus Earth is an Amazon rainforest conservation effort through the sale of virtual land
          of different sizes to represent real areas of the forest owned by Nemus. CyberKongz are{' '}
          <AppLink href="https://twitter.com/nemus_earth/status/1505319884464472068">
            partners
          </AppLink>{' '}
          and own a{' '}
          <AppLink href="https://opensea.io/assets/ethereum/0xd6acd704f1d8e007d934e1ec64838af3c8818015/1126">
            XX-Large plot
          </AppLink>
          .
        </Box>
        <Box>
          “The Genesis Drop includes a collection of 10,338 randomly generated NFTs, each one
          representing a unique parcel of land in the Seruini Region.”
        </Box>
      </>
    ),
  },
].map(({ id, label, ...rest }) => ({ cardImage: id, title: label, ...rest }));

export const CARDS_SOCIAL_IMPACT: CardSocialImpact[] = [
  {
    title: 'Orangutan outreach',
    description:
      'Orangutan Outreach protects orangutans in their native forests of Borneo and Sumatra, as well as caring for orphaned and displaced orangutans. Since 2021, CyberKongz has donated a portion of its sales and adopted six orangutans.',
    image: 'orangutan_outreach',
    badgeLabel: 'Ongoing',
    badgeColor: 'tertiary',
    href: LANDING_ROUTES.BLOG_POST('cyberkongz-vx-charity-donations'),
    subcards: [
      {
        title: 'MAR 7th, 21',
        description:
          'CyberKongz donate 60% of the proceeds from the sale of 989 CyberKongz to Cool Earth and Orangutan Outreach.',
        image: 'orangutan_outreach_1.png',
      },
      {
        title: 'Mar 13th, 21',
        description:
          'CyberKongz donates another 5 ETH to Orangutan Outreach and the adoption of 6 orangutans.',
        image: 'orangutan_outreach_2.jpg',
      },
      {
        title: 'Apr 28th, 21',
        description:
          'CyberKongz donate 2 ETH to Orangutan Outreach to celebrate their new Baby Mascot.',
        image: 'orangutan_outreach_3.jpg',
      },
    ],
  },
  {
    title: '138 ETH ($404,458) TO VIRUNGA NATIONAL PARK',
    description:
      'For World Gorilla Day, 24 September, 2021, CyberKongz auctions a custom 1/1 Baby CyberKongz named Matabishi for 69ETH and then matches the total and donates 138ETH to Virunga National Park.',
    image: 'virunga',
    badgeLabel: 'Supported',
    badgeColor: 'primary',
    href: 'https://virunga.org/',
    cardImage: 'virunga',
  },
  {
    title: '281.6 ETH ($1,213,611) TO VIRUNGA NATIONAL PARK',
    description: `CyberKongz participate in the Christie's auction for charity, donating 2 rare Genesis CyberKongz raising $1.2mm for the event on December 9th, 2021.`,
    image: 'christies',
    badgeLabel: 'Supported',
    badgeColor: 'primary',
    href: 'https://hypebeast.com/2021/12/christies-x-open-sea-nft-sale-cyberkongz',
    cardImage: 'christies',
  },
  {
    title: 'Set up home in Africarare',
    description:
      'CyberKongz is one of the newest early settlers in Africarare, the first metaverse in Africa. In this metaverse, visitors will be able to immerse themselves in the CyberKongz ecosystem and raise funds to support Virunga National Park conservation.',
    image: 'africacare',
    badgeLabel: 'Supported',
    badgeColor: 'primary',
    href: 'https://www.globenewswire.com/en/news-release/2022/10/25/2541266/0/en/CyberKongz-welcomed-to-Africarare-Africa-s-first-metaverse.html',
    cardImage: 'africacare',
  },
  {
    title: '20 ETH (64,564$) to COTAP.org',
    description:
      'The mission of Carbon Offsets To Alleviate Poverty (COTAP) is to empower individuals and organizations in developed countries to address both climate change and global poverty. This donation will offset the environmental impact through carbon emissions caused by the CyberKongz VX smart contract by a factor of 10! (4304 tonnes of CO2)',
    image: 'cotap',
    badgeLabel: 'Supported',
    badgeColor: 'primary',
    href: 'https://cotap.org/',
    cardImage: 'cotap',
  },
  {
    title: '50 ETH ($161,412) TO VIRUNGA NATIONAL PARK',
    description:
      ' After the CyberKongz VX mint, CyberKongz donated 50 ETH ($161,412) to Virunga National Park to help conservation efforts.',
    image: 'virunga',
    badgeLabel: 'Supported',
    badgeColor: 'primary',
    href: 'https://virunga.org/',
    cardImage: 'virunga_post_mint',
  },
];
